import { render, staticRenderFns } from "./SwitchDialog.vue?vue&type=template&id=6cc97998&"
import script from "./SwitchDialog.vue?vue&type=script&lang=js&"
export * from "./SwitchDialog.vue?vue&type=script&lang=js&"
import style0 from "./SwitchDialog.vue?vue&type=style&index=0&id=6cc97998&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports